export default {
  Estados: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "estados"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/Estados.js
// module id = noFn
// module chunks = 32